import * as types from '../mutation-types'
import entities from '../../api/entities'

// initial state
const state = {
  all: [],
  selectedId: 0,
  showIntroduction: 1
}

const getters = {
  allEntities: state => state.all,
  getSelectedId: state => state.selectedId,
  showIntroduction: state => state.showIntroduction
}

const actions = {
  getAllEntities ({ commit }) {
    entities.getEntities(entities => {
      commit(types.RECEIVES_ENTITIES, { entities })
    })
  }
}

const mutations = {
  [types.RECEIVES_ENTITIES] (state, { entities }) {
    state.all = entities
  },
  [types.ACTIVATED_ENTITY] (state, { id }) {
    state.selectedId = id
  },
  [types.SHOW_INTRODUCTION] (state) {
    state.showIntroduction = !state.showIntroduction
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/entities.js